import { jsx as ge } from "@emotion/react/jsx-runtime";
import { b as ve, N as Te } from "../global-behaviour/global-behaviour.js";
import { c as O, g as pe } from "../_commonjsHelpers.js";
import { useRef as V, useCallback as $, useEffect as ye } from "react";
const Se = (e) => {
  let r = !1, t = !1;
  const i = () => {
    r = !0, e.preventDefault();
  }, a = () => {
    t = !0, e.stopPropagation();
  };
  return {
    nativeEvent: e,
    currentTarget: e.currentTarget,
    target: e.target,
    bubbles: e.bubbles,
    cancelable: e.cancelable,
    defaultPrevented: e.defaultPrevented,
    eventPhase: e.eventPhase,
    isTrusted: e.isTrusted,
    preventDefault: i,
    isDefaultPrevented: () => r,
    stopPropagation: a,
    isPropagationStopped: () => t,
    persist: () => {
    },
    timeStamp: e.timeStamp,
    type: e.type
  };
}, H = (e, r) => {
  const t = new Event(r, { bubbles: !0 });
  return Object.defineProperty(t, "target", { writable: !1, value: e }), Object.defineProperty(t, "currentTarget", { writable: !1, value: e }), Se(t);
};
var q, X;
function ce() {
  if (X) return q;
  X = 1;
  function e(r) {
    var t = typeof r;
    return r != null && (t == "object" || t == "function");
  }
  return q = e, q;
}
var x, z;
function je() {
  if (z) return x;
  z = 1;
  var e = typeof O == "object" && O && O.Object === Object && O;
  return x = e, x;
}
var R, J;
function se() {
  if (J) return R;
  J = 1;
  var e = je(), r = typeof self == "object" && self && self.Object === Object && self, t = e || r || Function("return this")();
  return R = t, R;
}
var I, K;
function Oe() {
  if (K) return I;
  K = 1;
  var e = se(), r = function() {
    return e.Date.now();
  };
  return I = r, I;
}
var P, Q;
function he() {
  if (Q) return P;
  Q = 1;
  var e = /\s/;
  function r(t) {
    for (var i = t.length; i-- && e.test(t.charAt(i)); )
      ;
    return i;
  }
  return P = r, P;
}
var N, Y;
function _e() {
  if (Y) return N;
  Y = 1;
  var e = he(), r = /^\s+/;
  function t(i) {
    return i && i.slice(0, e(i) + 1).replace(r, "");
  }
  return N = t, N;
}
var w, Z;
function fe() {
  if (Z) return w;
  Z = 1;
  var e = se(), r = e.Symbol;
  return w = r, w;
}
var k, ee;
function Ee() {
  if (ee) return k;
  ee = 1;
  var e = fe(), r = Object.prototype, t = r.hasOwnProperty, i = r.toString, a = e ? e.toStringTag : void 0;
  function l(s) {
    var f = t.call(s, a), d = s[a];
    try {
      s[a] = void 0;
      var n = !0;
    } catch {
    }
    var c = i.call(s);
    return n && (f ? s[a] = d : delete s[a]), c;
  }
  return k = l, k;
}
var G, re;
function qe() {
  if (re) return G;
  re = 1;
  var e = Object.prototype, r = e.toString;
  function t(i) {
    return r.call(i);
  }
  return G = t, G;
}
var L, te;
function xe() {
  if (te) return L;
  te = 1;
  var e = fe(), r = Ee(), t = qe(), i = "[object Null]", a = "[object Undefined]", l = e ? e.toStringTag : void 0;
  function s(f) {
    return f == null ? f === void 0 ? a : i : l && l in Object(f) ? r(f) : t(f);
  }
  return L = s, L;
}
var D, ne;
function Re() {
  if (ne) return D;
  ne = 1;
  function e(r) {
    return r != null && typeof r == "object";
  }
  return D = e, D;
}
var M, ie;
function Ie() {
  if (ie) return M;
  ie = 1;
  var e = xe(), r = Re(), t = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || r(a) && e(a) == t;
  }
  return M = i, M;
}
var A, ae;
function Pe() {
  if (ae) return A;
  ae = 1;
  var e = _e(), r = ce(), t = Ie(), i = NaN, a = /^[-+]0x[0-9a-f]+$/i, l = /^0b[01]+$/i, s = /^0o[0-7]+$/i, f = parseInt;
  function d(n) {
    if (typeof n == "number")
      return n;
    if (t(n))
      return i;
    if (r(n)) {
      var c = typeof n.valueOf == "function" ? n.valueOf() : n;
      n = r(c) ? c + "" : c;
    }
    if (typeof n != "string")
      return n === 0 ? n : +n;
    n = e(n);
    var b = l.test(n);
    return b || s.test(n) ? f(n.slice(2), b ? 2 : 8) : a.test(n) ? i : +n;
  }
  return A = d, A;
}
var C, oe;
function Ne() {
  if (oe) return C;
  oe = 1;
  var e = ce(), r = Oe(), t = Pe(), i = "Expected a function", a = Math.max, l = Math.min;
  function s(f, d, n) {
    var c, b, T, m, o, g, v = 0, W = !1, y = !1, h = !0;
    if (typeof f != "function")
      throw new TypeError(i);
    d = t(d) || 0, e(n) && (W = !!n.leading, y = "maxWait" in n, T = y ? a(t(n.maxWait) || 0, d) : T, h = "trailing" in n ? !!n.trailing : h);
    function _(u) {
      var p = c, S = b;
      return c = b = void 0, v = u, m = f.apply(S, p), m;
    }
    function de(u) {
      return v = u, o = setTimeout(j, d), W ? _(u) : m;
    }
    function be(u) {
      var p = u - g, S = u - v, U = d - p;
      return y ? l(U, T - S) : U;
    }
    function F(u) {
      var p = u - g, S = u - v;
      return g === void 0 || p >= d || p < 0 || y && S >= T;
    }
    function j() {
      var u = r();
      if (F(u))
        return B(u);
      o = setTimeout(j, be(u));
    }
    function B(u) {
      return o = void 0, h && c ? _(u) : (c = b = void 0, m);
    }
    function le() {
      o !== void 0 && clearTimeout(o), v = 0, c = g = b = o = void 0;
    }
    function me() {
      return o === void 0 ? m : B(r());
    }
    function E() {
      var u = r(), p = F(u);
      if (c = arguments, b = this, g = u, p) {
        if (o === void 0)
          return de(g);
        if (y)
          return clearTimeout(o), o = setTimeout(j, d), _(g);
      }
      return o === void 0 && (o = setTimeout(j, d)), m;
    }
    return E.cancel = le, E.flush = me, E;
  }
  return C = s, C;
}
var we = Ne();
const ue = /* @__PURE__ */ pe(we), ke = "ViewObserver", Ge = ["onEnter", "onExit"], Ce = (e) => {
  const r = ve(ke, Ge, e, Te), {
    onEnter: t,
    onExit: i,
    id: a,
    threshold: l = 0,
    root: s = null,
    rootMargin: f = "0px",
    debounceMS: d = 250,
    children: n
  } = r, c = V(null), b = V(!1), T = $(
    ue((o) => {
      t(o);
    }, d),
    [t]
  ), m = $(
    ue((o) => {
      i(o);
    }, d),
    [i]
  );
  return ye(() => {
    if (!c.current)
      return;
    const o = new IntersectionObserver(
      ([g]) => {
        if (g.isIntersecting) {
          if (!b.current) {
            b.current = !0;
            const v = H(c.current, "enter");
            T(v);
          }
        } else if (b.current) {
          b.current = !1;
          const v = H(c.current, "exit");
          m(v);
        }
      },
      {
        root: s,
        rootMargin: f,
        threshold: l
      }
    );
    return o.observe(c.current), () => {
      o.disconnect(), T.cancel(), m.cancel();
    };
  }, [T, m, s, f, l]), /* @__PURE__ */ ge("div", { "data-tracking-id": a, ref: c, children: n });
};
export {
  Ce as V
};
